export default __webpack_public_path__ + "static/media/HAMBURGER MENU (1).52e57cbb.svg";